export default "__VITE_ASSET__BWAAmedi__";